// 介面圖示：統一使用 Lucide 的線條圖示（逐一引入，只打包用到的）。
// 在這裡集中列出，換圖示或調整預設樣式只改一處；元件不直接從 lucide-react 引入。
export {
  ArrowUp,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarX,
  Check,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CloudOff,
  Compass,
  Download,
  ExternalLink,
  History,
  House,
  Info,
  Layers,
  LayoutGrid,
  Link2,
  List,
  LogOut,
  type LucideIcon,
  Monitor,
  Moon,
  Pause,
  Play,
  RefreshCw,
  Search,
  SearchX,
  SlidersHorizontal,
  Sun,
  TriangleAlert,
  WifiOff,
  X,
  Zap,
} from 'lucide-react';

/** 所有圖示共用的尺寸與線寬（隨文字大小縮放） */
export const ICON = { size: '1.15em', strokeWidth: 2, 'aria-hidden': true } as const;
